import React from "react";
import { Box, IconButton, Typography, CircularProgress } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import FilterListIcon from "@mui/icons-material/FilterList";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";

type MobilePageHeaderProps = {
  title: string;
  subtitle?: string;
  isBusy?: boolean;
  onOpenFilters?: () => void;
  onOpenKnowledge?: () => void;
  knowledgeActive?: boolean;
  onRefresh?: () => void;
  onSignOut?: () => void;
  showSignOut?: boolean;
  filterActive?: boolean;
};

export function MobilePageHeader({
  title,
  subtitle,
  isBusy = false,
  onOpenFilters,
  onOpenKnowledge,
  knowledgeActive = false,
  onRefresh,
  onSignOut,
  showSignOut = false,
  filterActive = false,
}: MobilePageHeaderProps) {
  return (
    <Box
      sx={{
        flexShrink: 0,
        px: 1.5,
        pt: 1.25,
        pb: 1,
        bgcolor: "#fff",
        borderBottom: "1px solid #e5e9ef",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
        }}
      >
        <Box sx={{ minWidth: 0 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: "#1f2937",
              lineHeight: 1.2,
            }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="caption" sx={{ color: "#6b7280" }}>
              {subtitle}
            </Typography>
          )}
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 0.25 }}>
          {isBusy && <CircularProgress size={18} sx={{ color: "#5fa67a", mr: 0.5 }} />}
          {onOpenFilters && (
            <IconButton
              size="small"
              onClick={onOpenFilters}
              aria-label="Open filters"
              sx={{
                color: filterActive ? "#5fa67a" : "#64748b",
                bgcolor: filterActive ? "#eef7f1" : "transparent",
              }}
            >
              <FilterListIcon fontSize="small" />
            </IconButton>
          )}
          {onOpenKnowledge && (
            <IconButton
              size="small"
              onClick={onOpenKnowledge}
              aria-label="Open help and guides"
              sx={{
                color: knowledgeActive ? "#5fa67a" : "#64748b",
                bgcolor: knowledgeActive ? "#eef7f1" : "transparent",
              }}
            >
              <MenuBookOutlinedIcon fontSize="small" />
            </IconButton>
          )}
          {onRefresh && (
            <IconButton
              size="small"
              onClick={onRefresh}
              aria-label="Refresh"
              sx={{ color: "#5fa67a" }}
            >
              <RefreshIcon fontSize="small" />
            </IconButton>
          )}
          {showSignOut && onSignOut && (
            <IconButton
              size="small"
              onClick={onSignOut}
              aria-label="Sign out"
              sx={{ color: "#64748b" }}
            >
              <ExitToAppIcon fontSize="small" />
            </IconButton>
          )}
        </Box>
      </Box>
    </Box>
  );
}
